import * as React from "react";
import { useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { request, resourceLink } from "../../services/cpln";
import { Loader } from "../../components/layout/loader";
import { DetailContext } from "../../components/detail/detailContext";
import { Helmet } from "react-helmet";
import { IS_DEPLOYMENT_ENV_TEST } from "../../envVariables";
import { NGFormData } from "../../mobxStores/ngFormData";
import { NGFormContext } from "../../reactContexts/ngFormContext";
import { IpSet } from "../../schema/types/ipset";
import { IpSetDetail } from "./detail";
import { captureExc } from "../../errorBoundary";

type RouteParams = "ipset";
const IpSetDetailRouteRaw: React.FC = () => {
  const formDataRef = React.useRef(new NGFormData());
  const { ipset: ipsetName } = useParams<RouteParams>();
  const [ipset, setIpset] = React.useState<IpSet>(null as any);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isIncorrect, setIsIncorrect] = React.useState(false);

  React.useEffect(() => {
    fetchItem();
  }, [ipsetName]);

  async function fetchItem() {
    try {
      setIsLoading(true);
      const { data } = await request({ url: resourceLink("ipset", ipsetName) });
      setIpset(data);
      setIsLoading(false);
    } catch (e) {
      captureExc(e);
      setIsIncorrect(true);
      setIsLoading(false);
    }
  }

  if (isLoading) {
    return <Loader fullScreen reason={"fetching ip set to show detail"} />;
  }

  if (isIncorrect) {
    return <IncorrectItem kind={"ipset"} canCreate={true} />;
  }

  return (
    <>
      <Helmet>
        <title>
          {IS_DEPLOYMENT_ENV_TEST ? `TEST | ` : ""}
          {ipset.name} - Ip Set - From many clouds, one™
        </title>
      </Helmet>
      <DetailContext.Provider value={{ item: ipset, fetchItem }}>
        <NGFormContext.Provider value={formDataRef.current}>
          <IpSetDetail ipset={ipset} />
        </NGFormContext.Provider>
      </DetailContext.Provider>
    </>
  );
};

export const IpSetDetailRoute = observer(IpSetDetailRouteRaw);
